export enum D365TemplateName {
    EntityRecord = 'msdyn_entityrecord',
    Dashboard = 'egl_dashboard',
    EntityList = 'egl_entitylist',
}
